<template>
  <div>
    <div v-if="label">
      {{ label }}
    </div>
    <input
      v-bind="$attrs"
      :value="type === 'date' ? dateToInputDate(`${modelValue}`) : modelValue"
      :checked="type === 'checkbox' && modelValue as boolean"
      class="px-3 py-4 border-neutral-500 rounded hover:border-neutral-800 focus:border-neutral-800"
      @input="onInput"
      :placeholder="placeholder"
      :type="type"
      :id="id"
      @click="activateField"
    />

    <div class="text-red-400" v-if="error">
      <!-- We always show this to prevent the layout from jumping around -->
      {{ error ? error : 'ㅤ' }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { dateToInputDate } from '@planbord/shared/dates';

const emit = defineEmits<{ (e: 'update:modelValue', value: unknown): void }>();
const props = withDefaults(
  defineProps<{
    label?: string;
    error?: string;
    modelValue: unknown;
    type?: string;
    placeholder?: string;
    id?: string;
    borderError?: boolean;
    loading?: boolean;
  }>(),
  {
    borderError: false,
    loading: false,
  }
);

function onInput(e: Event) {
  const target = e.target as HTMLInputElement;
  emit(
    'update:modelValue',
    props.type === 'checkbox' ? target.checked : target.value
  );
}

function activateField(e: Event) {
  if (props.type === 'date' || props.type === 'time') {
    const target = e.target as HTMLInputElement;
    target.showPicker();
  }
}
</script>

<style scoped>
/* change the color of the checked state of the checkbox input to bg-primary-800 */
input[type='checkbox']:checked {
  @apply accent-primary-800;
}
</style>
